module.exports = __webpack_public_path__ + "img/network.699646f.png";